(function() {
  function extractInhaltsstoffe() {
    const container = document.getElementById('inhaltsstoffe-cards-container');
    if (!container) return;

    container.innerHTML = '';

    const allAccordions = document.querySelectorAll('.product__accordion details');
    const duftTabs = [];

    const menDufte = ['VINTAGE HAVANA', 'DYNAMIC PULSE', 'TIMELESS APPEAL', 'NOBLE AURA'];
    const womenDufte = ['VELVET BLOOM', 'MIMOSA WHISPER', 'GOLDEN FEMME', 'TWILIGHT SERENADE'];
    const allDufte = [...menDufte, ...womenDufte];

    const icons = {
      'VINTAGE HAVANA': '🥃',
      'DYNAMIC PULSE': '⚡',
      'TIMELESS APPEAL': '⏰',
      'NOBLE AURA': '👑',
      'VELVET BLOOM': '🌺',
      'MIMOSA WHISPER': '🌼',
      'GOLDEN FEMME': '✨',
      'TWILIGHT SERENADE': '🌙'
    };

    allAccordions.forEach(details => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      const heading = summary.querySelector('.accordion__title')?.textContent || '';
      const duftName = heading.split('(')[0].trim().replace(/\*NEU\*/g, '').trim();
      const subM = heading.match(/\(([^)]+)\)/);
      const subtitle = subM ? subM[1].trim() : '';
      const displayTitle = duftName + (subtitle ? ' (' + subtitle + ')' : '');
      const isDuft = allDufte.some(duft => duftName.toUpperCase().includes(duft));
      if (!isDuft) return;

      let fullContent = content.innerHTML;
      /* Duftbild-Block (Rauchig-würzig, Warm süßlich gourmand, Tief maskulin etc.) entfernen */
      fullContent = fullContent.replace(/<p><strong>Duftbild:<\/strong><br\s*\/?>[\s\S]*?<\/p>/gi, '');

      const inhaltsstoffeMatch = content.innerHTML.match(/Inhaltsstoffe & Wirkung:([\s\S]*?)(?:<p>|$)/i);
      let inhaltsstoffe = [];
      if (inhaltsstoffeMatch) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = inhaltsstoffeMatch[1];
        const strongElements = tempDiv.querySelectorAll('strong');
        strongElements.forEach(strong => {
          const name = strong.textContent.trim();
          if (name && !/^(Wir|Rizinusöl|Propanediol|Glycerin|natürlichen|Inhaltsstoffe|Inhaltsstoffe & Wirkung)/i.test(name)) {
            let desc = '';
            let nextNode = strong.nextSibling;
            while (nextNode && nextNode.nodeType !== 1) nextNode = nextNode.nextSibling;
            if (nextNode && nextNode.textContent) desc = nextNode.textContent.trim().replace(/^[\s\(\),-]+/, '');
            if (name.length > 2 && name.length < 50) inhaltsstoffe.push({ name: name, description: desc });
          }
        });
        if (inhaltsstoffe.length === 0) {
          tempDiv.querySelectorAll('li').forEach(li => {
            const text = li.textContent.trim();
            if (text && !/^(Wir|Rizinusöl|Propanediol|Glycerin)/i.test(text) && text.length > 3) {
              const parts = text.split('(');
              inhaltsstoffe.push({ name: parts[0].trim(), description: parts[1] ? '(' + parts[1] : '' });
            }
          });
        }
      }

      if (!duftName || (inhaltsstoffe.length === 0 && !fullContent)) return;

      let icon = '🌸';
      for (const [key, value] of Object.entries(icons)) {
        if (duftName.toUpperCase().includes(key)) { icon = value; break; }
      }

      duftTabs.push({ name: duftName, displayTitle: displayTitle, icon: icon, fullContent: fullContent, inhaltsstoffe: inhaltsstoffe.slice(0, 8) });
    });

    if (duftTabs.length === 0) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'inhaltsstoffe-cards-wrapper';

    duftTabs.forEach((duft, index) => {
      const card = document.createElement('div');
      card.className = 'inhaltsstoffe-card';

      const modalId = 'inhaltsstoffe-detail-modal-' + index;
      let detailHtml = '';
      if (duft.fullContent) {
        detailHtml = `<div class="inhaltsstoffe-detail-content rte">${duft.fullContent}</div>`;
      } else if (duft.inhaltsstoffe.length > 0) {
        detailHtml = '<ul class="inhaltsstoffe-list">' + duft.inhaltsstoffe.map(ing =>
          `<li class="inhaltsstoffe-list-item"><strong>${ing.name}</strong>${ing.description ? ': ' + ing.description : ''}</li>`
        ).join('') + '</ul>';
      }

      card.innerHTML = `
        <button type="button" class="inhaltsstoffe-card-header" data-index="${index}" aria-expanded="false" aria-controls="${modalId}">
          <span class="inhaltsstoffe-card-icon">${duft.icon}</span>
          <h3 class="inhaltsstoffe-card-title">${duft.displayTitle}</h3>
          <span class="inhaltsstoffe-card-arrow" aria-hidden="true"></span>
        </button>
        <div class="inhaltsstoffe-detail-modal" id="${modalId}">
          ${detailHtml}
        </div>
      `;

      const btn = card.querySelector('.inhaltsstoffe-card-header');
      const modal = card.querySelector('.inhaltsstoffe-detail-modal');
      const arrow = card.querySelector('.inhaltsstoffe-card-arrow');

      btn.addEventListener('click', function() {
        const isOpen = modal.classList.contains('active');
        modal.classList.toggle('active', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen);
        arrow.classList.toggle('active', !isOpen);
        if (!isOpen) modal.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      wrapper.appendChild(card);
    });

    container.appendChild(wrapper);
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(extractInhaltsstoffe, 500); });
    } else {
      setTimeout(extractInhaltsstoffe, 500);
    }
    const observer = new MutationObserver(function() {
      const container = document.getElementById('inhaltsstoffe-cards-container');
      if (container && container.children.length === 0) extractInhaltsstoffe();
    });
    setTimeout(function() {
      const main = document.querySelector('.product__info-wrapper') || document.querySelector('#MainProduct-main');
      if (main) observer.observe(main, { childList: true, subtree: true });
    }, 1000);
  }

  init();
})();
